import i18next from 'i18next';

export const numberFormat = (number: number, decimal = 2) => {
    // Show integers for numbers between 1,000 and 9,999,999
    // Use compact for >= 10,000,000
    // Preserve decimals for small numbers
    let useCompact = false;
    let minDecimals = 1;
    let maxDecimals = decimal;
    const absNum = Math.abs(number);

    if (absNum < 1000) {
        // Small numbers, show decimals
        minDecimals = 0;
        maxDecimals = decimal;
    } else if (absNum < 10000000) {
        // Show as integer, never compact
        minDecimals = 0;
        maxDecimals = 1;
    } else {
        // Use compact notation for 10,000,000 and above
        useCompact = true;
        minDecimals = 0;
        maxDecimals = 1;
    }

    if (minDecimals > maxDecimals) {
        minDecimals = maxDecimals;
    }

    const formatter = new Intl.NumberFormat(i18next.language, {
        style: 'decimal',
        notation: useCompact ? 'compact' : 'standard',
        maximumFractionDigits: maxDecimals,
        minimumFractionDigits: minDecimals,
    })
        .format(number)
        .replace(/(\.0+|,0+)$/, ''); // remove double trailing zeros

    return formatter;
};
